export default __webpack_public_path__ + "static/media/wssap.00dcdaec.png";